import { Injectable, Type } from '@angular/core';
import { Collection } from './component-loader';

@Injectable({
  providedIn: 'root'
})

export class CollectiveComponentLoaderService {

  constructor() { }

  private collective: Collection = {};

  register(key: string, components: any): void { this.collective[key] = components; }

  get(): Collection { return this.collective; }

  getByKey(key: string): Type<any>[] { return this.collective[key]; }
}
